import { takeLatest, ForkEffect } from "redux-saga/effects"
import ActionTypes from "../../enums/ActionTypes"
import { API_SERVER_USER } from "../../constants/api"
import { createLock } from "./createLock"

interface TerminalLockResponse {
  token: string
}

const lockTerminal = createLock({
  resourcePath: `${API_SERVER_USER}/terminals`,
  successAction: ActionTypes.TERMINAL_LOCK_SUCCESS,
  failureAction: ActionTypes.TERMINAL_LOCK_FAILURE,
  successMessage: "pages.terminal.activated",
  failureMessage: "pages.terminal.notActivated",
  getTokenFromResponse: (res: TerminalLockResponse) => res.token,
})

const terminalSagas: ForkEffect[] = [
  takeLatest(ActionTypes.TERMINAL_LOCK_REQUEST, lockTerminal),
]

export default terminalSagas